import { create } from 'zustand';
import { v4 as uuidv4 } from 'uuid';

// 모달 아이템 타입 정의
interface ModalItem {
  id: string;
  modalType: string;
  modalProps: Record<string, unknown>;
}

// 모달 스토어 타입 정의
interface ModalStore {
  modalStack: ModalItem[];
  openModal: (modalType: string, props?: Record<string, unknown>) => string; // 모달 ID 반환
  closeModal: (id?: string) => void; // 특정 ID를 닫거나 최상위 모달 닫기
  closeAllModals: () => void;
}

// 스택 모달 관리 (기본: 여러 모달이 동시에 표시될 수 있음)
export const useStackModalStore = create<ModalStore>((set) => ({
  modalStack: [],
  
  // 모달 열기 액션
  openModal: (modalType, props = {}) => {
    const id = uuidv4(); // 고유 ID 생성
    set(state => ({
      modalStack: [...state.modalStack, { id, modalType, modalProps: props }]
    }));
    return id;
  },
  
  // 모달 닫기 액션
  closeModal: (id) => {
    // ID가 제공되면 해당 모달만 닫고, 아니면 최상위 모달 닫기
    if (id) {
      set(state => ({
        modalStack: state.modalStack.filter(modal => modal.id !== id)
      }));
    } else {
      set(state => ({
        modalStack: state.modalStack.slice(0, -1)
      }));
    }
  },
  
  // 모든 모달 닫기
  closeAllModals: () => set({ modalStack: [] }),
}));

// 단일 모달 관리 : 하나의 모달만 표시해야 할 때 사용
export const useSingleModalStore = () => {
  const { modalStack, openModal: openModalNew, closeModal: closeModalNew } = useStackModalStore();
  
  return {
    modalType: modalStack.length > 0 ? modalStack[modalStack.length - 1]?.modalType : null,
    modalProps: modalStack.length > 0 ? modalStack[modalStack.length - 1]?.modalProps : {},
    openModal: (modalType: string, props: Record<string, unknown> = {}) => {
      openModalNew(modalType, props);
    },
    closeModal: () => closeModalNew()
  };
};
